import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useEffect,
} from "react";
import { setToken, getToken, deleteToken, setEmpresaCliente, getEmpresaCliente } from "../helpers/usuario";
import clienteAxios, {
  resetSessionExpiredAlert,
} from "../helpers/clienteAxios";

import { useIniciarSesion } from "../queries/config/LoginQuery";
import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import useContratos from "../queries/config/useContratos";
import { useLoading } from "./loadingContext";
import { useNavigate } from "react-router-dom";

const UsuarioContext = createContext();
const UsuarioProvider = (props) => {
  const { setLoading, removeLoading } = useLoading();
  const queryContratos = useContratos();
  const [usuario, setUsuario] = useState(null);
  const [contratos, setContratos] = useState(null);
  const [contratoSeleccionado, setContratoSeleccionado] = useState(null);
  const [tipoCLiente, setTipoCliente] = useState(null);
  const navigate = useNavigate();

  const { mutate, isLoading: cargandoUsuario } = useMutation(useIniciarSesion, {
    onSuccess: (response) => {
      setToken(response.token);
      setEmpresaCliente(response.data);
      getUsuario();

      
      navigate("/");

      
      let dataDinal = JSON.parse(response.data);

      if (dataDinal.Particular == 1 && dataDinal.Empresa == 1) {
        setTipoCliente("DOMICILIARIO");
      }
      if (dataDinal.Particular == 1 && dataDinal.Empresa == 0) {
        setTipoCliente("DOMICILIARIO");
      }
      if (dataDinal.Particular == 0 && dataDinal.Empresa == 1) {
        setTipoCliente("EMPRESA");
      }


      resetSessionExpiredAlert();
    },
    onError: (error) => {
      deleteToken();
      Swal.fire({
        icon: "error",
        title: error.response.data.error.detalleRespuesta,
        html: `<p>Por favor, vuelve a ingresar tus datos de acceso.</p>`,
        confirmButtonText: "Volver",
        focusConfirm: false,
        iconColor: "red",
        width: "40rem",
        customClass: {
          popup: "containerSwal",
          title: "titleSwal",
          closeButton: "...",
          icon: "iconSwal",
          confirmButton: "buttonSwal",
          denyButton: "...",
          cancelButton: "...",
        },
      });
      removeLoading({ id: "login" });
    },
  });

  const [contratosProcesados, setContratosProcesados] = useState(false);

useEffect(() => {
  const cargarContratos = async () => {
    if (contratosProcesados || !contratos) return;

    const contratoSeleccionado = contratos.find((contrato) => contrato.unidad_negocio === 1);

    if (!contratoSeleccionado && contratos.length > 0) {
      setContratoSeleccionado(contratos[0]);
    } else if (contratoSeleccionado) {
      setContratoSeleccionado(contratoSeleccionado);
    }

    setContratosProcesados(true);
  };

  cargarContratos();
}, [contratos]);

  

  const loginUsuario = async (form) => {
    setLoading({ id: "login" })
    mutate(form);
  };

  const getUsuario = async (data) => {

    if (!getToken()) {
      return;
    }

    setLoading({ id: "login" })
    try {

      let dataDinal = getEmpresaCliente();
      if (dataDinal.Particular == 0 && dataDinal.Empresa == 1) {
        setTipoCliente("EMPRESA");
      } else {
        setTipoCliente("DOMICILIARIO");
      }

      await clienteAxios
        .get("sucursalVirtual/dataContacto")
        .then(async (response) => {
          if (!response.data.error) {
            let datosResp = response?.data?.success?.descripcionRespuesta[0]
              ? response?.data?.success?.descripcionRespuesta[0]
              : "";

            let datosUsuario = {
              id: datosResp.clie_id,
              Nombres: datosResp.nombre ? datosResp.nombre : "",
              ApPaterno: datosResp.apellido1 ? datosResp.apellido1 : "",
              ApMaterno: datosResp.apellido2 ? datosResp.apellido2 : "",
              RutClient: datosResp.rut ? datosResp.rut : "",
              Correo: datosResp.email ? datosResp.email : "",
              Telefono: datosResp.telefono ? datosResp.telefono : "",
              Pac: datosResp.pac ? datosResp.pac : null,
              UrlSuscripcionPat: datosResp.url_suscripcion_pat ? datosResp.url_suscripcion_pat : null,
              Permisos: datosResp.permisos ?? null
            };

            const contratoCliente = await queryContratos.mutateAsync({
              rutCliente: datosUsuario.RutClient,
            });
            setUsuario(datosUsuario);
            setContratos(contratoCliente.success.descripcionRespuesta);
            setContratoSeleccionado(
              contratoCliente.success.descripcionRespuesta[0]
            );
          }
          removeLoading({ id: "login" });
        });
    } catch (error) {
      removeLoading({ id: "login" });

    }
  };

  const logout = () => {
    setUsuario(null);
    deleteToken();
  };

  useEffect(() => {
    getUsuario();
  }, []);

  const value = useMemo(() => {
    return {
      usuario,
      cargandoUsuario,
      tipoCLiente,
      loginUsuario,
      logout,
      contratos,
      contratoSeleccionado,
      setContratoSeleccionado,
      setContratos
    };
  }, [
    usuario,
    cargandoUsuario,
    tipoCLiente,
    loginUsuario,
    logout,
    contratos,
    contratoSeleccionado,
    setContratoSeleccionado,
    setContratos
  ]);

  return <UsuarioContext.Provider value={value} {...props} />;
};

const useUsuario = () => {
  return useContext(UsuarioContext);
};

export { UsuarioProvider, useUsuario };
